// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import packageInfo from '../../package.json'

export const environment = {
  production: false,
  analyticsKey: 'prodAnalytics',
  progressKey: 'Progress',
  name: 'cancerdiagnosticeducation',
  appName: 'Modal',
  urlScheme: '',
  appId: 'com.modaldigital.rochediag',
  version: packageInfo.version,
  homePage: [''],
  scormEngine: 'https://api.cancerdiagnosticeducation.com',
  searchApiUrl: 'https://app.cancerdiagnosticeducation.com/apis/rustici-course-search',
  searchApiBearerToken: '693jy1yzGt3lFSMbjo89ULC79Kh5yAHbse_rYWVw6b4',
  recommendationsApiUrl: 'https://modal-recommends.demo.modaldigital.io/generate_recommendations',
  globalScormTenantId: 'cm2klzq7x024mrs0hfasvj7ec',
  firebaseRegion: 'us-central1',
  authConfig: {
    domain: 'auth.cancerdiagnosticeducation.com',
    clientId: 'wjJ89NIWOnAOho0GX0Vl2i0HpZnOhql4',
    audience: 'https://app.cancerdiagnosticeducation.com',
    responseType: 'token id_token'
  },
  firebaseConfig: {
    apiKey: 'AIzaSyCjUmUcy5WnD39UCj8R6Pfkrw6x075zQ5Y',
    authDomain: 'modal-rochediag.firebaseapp.com',
    databaseURL: 'https://modal-rochediag-default-rtdb.firebaseio.com',
    projectId: 'modal-rochediag',
    storageBucket: 'modal-rochediag.appspot.com',
    messagingSenderId: '309336256084',
    appId: '1:309336256084:web:27644bb73982a7d6be87c1',
    measurementId: 'G-R5GRL8RH6K',
    vapidKey: 'z1QYzqQIHJ9PYYCR_Kq2Vh08UYwOUhyOpJYU5vqEEIeIvGxzIHax6m6qOB8iV4aZ10',
    fallbackUrl : 'https://bocoweb.prod.bocodigital.com/ios/apps/roche/v4',
    iamId: 'modal-rochediag-state'
  },
  pspdfkit: {
    nativeLicense:
      '',
    license:
      //! LOCALHOST
      // 'faYVJD7CV3J7USDgGuWZW5nS5hVaS2TrdC2YPoXFIFbriTV5ZTUZN6KXZm6AlYNXnhT6pDp4Aji7Far1rFnZXA7_z6l-DLc5Rr6HGHJQX3Zv_Wm9t7rHy3fwU3cfXWdEGv431Wv35JP-3L4eFs0lt7bxUdgTor8EcY8k003lQJCMKbg6_V0mSBnI9ap1d5tDot5W2D8PXPrRqW079WUZuLliDbzF6PdaLQESqF7oIoI_qpYT4IZo1G9BhjlwNxSuoJ7J-HNEyiRCl-9sBwBfmn0MVaXg4J3kr3GiGsKjHhY0x27lB2z7C_FTj7R1dSnSEW9Bd9TIkXue_vtwRhurs-3-OsIEwYhT6vW9kur3-BZrL4AsuCNg0qpK5Q2l5-_UPt9EN6Sp6zh3ELWgycs7z99TBZw9ksxCa4b8n1ndGkJg4HWI9YmTvgYpJXlo_vJbtoXN6P9YCsefL5f226deBCgAKGB9O9-Qyzg_TwkceNbAcFkMu68t2UkClW0oJ_PmyxwHiDlqz5bQ25JiRK9U7YBPbT13u2QSWAT12iIf9DoEbsbjoj_KCKTpbnzFSrm6-xHn2CAJDNhHxpCwjTc8BLMMvRcnUadU1Qv8rqaftAQ=',
      //! PRODUCTION
      'ha0JTaw-LLImWse_c7-uSgIQTP1Ug1rd4uI2eG1FU7rGvuZDyDMOFnkerr_HQJ-FhZKIa7_-GvjbX0RpeHgYEyLgxWtOcpJEZfzYcBqhRcXtTHTbg5xevmiXhZcfONlluBDppdeYWuingaxJtQ6nsLZzgfC8iqAEfpkXwpR-Z415CobzCDjAuL6KPpK7uj13kH9p4MFk8ARg3rmrTO068CMPZvw_h14DuMMo2P_jbKM0oZaYFdDckXiIDdp8DEccyM5HH4eZMEHPKeHyOH9EfFM5pSg_AQ4gp_H7r10rskhRX8i_u8S4UOIJtEVP4eBkFwH8d1tOwgI_DrkSjAXOlyvmz7cegJ5RpN56J23a2xw0hUv5c55xEdweBSl2IWmKin0w3QvexojGsgmtuty0T3MFwGutK1QUpwN8jTHPI7r2CCAP1wsVl0l3rANGQTi1_GsSEvAgyaV1TZXyiGuWORFBEwbQvq77zGnnN7fLm0yU1MVuvf_3NokHcXJdNwxnlCAfszFOAVmUPB3t018jL24vox2E7y4nSwE5rtuhI7r05_B-VkZQSzOaWYw_cd4WacBDfB97g2KG26EP--idd4_Sq55M0lsR5ES0oOiWb5UyTL4nlwTQ5q4v5OEfzJg5'
  },
  firebasePaths: {
    state: 'environment/production/iam/state/',
    space: 'environments/production/'
  },
  appLanguage: {
    general: {
      networkConnectionMessageHeader: 'Network connection is required',
      networkConnectionMessage:
        'I am sorry. To use this resource, you must be connected to the Internet.',
      connectionLost: 'Your connection to the internet was lost.',
      connectionFound: 'Your internet connection seems to have returned.',
      reloadMessage: 'Please press OK to reload.',
      showMe: 'Show Me',
      downLoading: 'Downloading',
      dismiss: 'Dismiss',
      disclaimer:
        'FOR EDUCATIONAL USE ONLY'
    },
    topNav: {
      loggedInAs: 'Logged in as',
      since: 'since',
      availableLayouts: 'Available Layouts',
      favorites: 'Favorites',
      preferences: 'Preferences',
      logOutNow: 'Logout now',
      yes: 'Yes',
      no: 'No',
      areYouSure: 'Are you sure?',
      sorry: 'Sorry',
      okay: 'Okay',
      maybeLater: 'Maybe Later'
    },
    modals: {
      workingOffline: 'You are working offline',
      preferences: {
        profile: 'Profile',
        dataManagement: 'Data Management',
        total: 'Total',
        allStorage: 'All Storage',
        features: 'Features',
        notifications: 'Notifications',
        defaultLayout: 'Default dashboard',
        defaultLayoutMessage:
          'Select a dashboard below to change the default dashboard.',
        defaultLayoutDisclaimer:
          'the dashboard can always be changed using the drop down menu at the top right at any time.',
        close: 'Close'
      },
      updateInProgressHeader: 'Update in progress',
      updateInProgressMessage:
        'Your dashboard and resources are being updated to reflect recent changes.',
      contentUnavailableHeader: 'This content is no longer available.',
      contentUnavailableMessage:
        'This content has been disabled. Please return to the main dashboard.',
      chooseLayoutHeader: 'Would you like to make this your default dashboard?',
      chooseLayoutMessage:
        'You can change the dashboard later by clicking on the avatar in the upper right corner of the application. You can also change your default dashboard by going to preferences.',
      logout: 'Logout',
      logOutMessage: 'You will be redirected to the login screen momentarily.'
    },
    widget: {
      disabled: 'Disabled',
      waiting: 'Waiting',
      week: 'Week',
      todaysTasks: 'Todays Tasks',
      noTasks: 'Today there are no tasks.',
      youHaveNoTasks: '',
      forCurrentWeek: '',
      minutes: 'mins',
      keyObjectives: 'Key Objectives',
      todoThisWeek: 'Tasks for this week'
    },
    library: {
      noFavoritesHeader: 'No favorites',
      noFavoritesMessage: 'You have not marked any favorites.',
      folderMessage: 'inside this folder',
      pages: 'pages',
      open: 'Open',
      myFavorites: 'My Favorites'
    },
    agenda: {
      viewPdf: 'View PDF',
      time: 'Time',
      description: 'Description',
      location: 'Location'
    },
    roadmap: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      week: 'Week',
      noTasksThisDay: '',
      checkAll: 'Check all',
      unCheckAll: 'Uncheck all',
      acknowledgement: '',
      acknowledgementModalSubmit: ''
    },
    quiz: {
      quiz: 'Knowledge Check',
      begin: 'Begin',
      close: 'Close',
      submit: 'Submit',
      correct: 'Correct',
      incorrect: 'Incorrect',
      continue: 'Continue',
      sorry: 'You did not successfully achieve a passing score.',
      congratulations: 'Congratulations!'
    }
  }
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
